import { ROOT_PROJECT, type Project } from '@mac-remote/protocol';

/**
 * What to print for a project identifier.
 *
 * Everything except the root is its own label. `__root__` is a wire sentinel and must
 * never reach the screen — the agent sends the folder's real name as `label`, and the
 * fallback covers the seconds before the project list has arrived (a session tab can
 * be on screen from a reconnect before `s.projects` lands).
 */
export function projectLabel(name: string, projects: Project[]): string {
  if (name !== ROOT_PROJECT) return name;
  return projects.find((p) => p.name === ROOT_PROJECT)?.label ?? 'корень';
}
